import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import classnames from 'classnames';
import Lib from '../../commons/lib';
import FeladatlistaContent from './FeladatlistaContent';
import AllapotContent from './AllapotContent';
import FeladatTipusContent from './FeladatTipusContent';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './FeladatlistaTooltips';

class FeladatListaMenuBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: undefined,
    };
  }

  componentDidMount() {
    this.initTab();
  }

  initTab = () => {
    let activeTab = '1';
    if (this.props.globals.hasRole(['FELADATLISTA_FELADATTIPUS'])) activeTab = '3';
    if (this.props.globals.hasRole(['FELADATLISTA_FELADATTIPUS'])) activeTab = '2';
    if (this.props.globals.hasRole(['FELADATLISTA_FELADAT'])) activeTab = '1';

    this.setState({ activeTab: activeTab });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Feladatlista
              <CustomTooltip text={getTooltip('feladatlista')} id="feladatlistaTT" />
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.globals.hasRole(['FELADATLISTA_FELADAT'])
                  && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Feladatok
                        <CustomTooltip text={getTooltip('feladatok')} id="feladatokTT" />
                      </NavLink>
                    </NavItem>
                  )
                  }
                  {this.props.globals.hasRole(['FELADATLISTA_FELADATTIPUS'])
                  && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggle('2'); }}
                      >
                        Feladattípus állapotok
                        <CustomTooltip text={getTooltip('feladattipusallapotok')} id="feladattipusallapotokTT" />
                      </NavLink>
                    </NavItem>
                  )
                  }
                  {this.props.globals.hasRole(['FELADATLISTA_FELADATTIPUS'])
                  && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => { this.toggle('3'); }}
                      >
                        Feladattípusok
                        <CustomTooltip text={getTooltip('feladattipusok')} id="feladattipusokTT" />
                      </NavLink>
                    </NavItem>
                  )
                  }
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.props.globals.hasRole(['FELADATLISTA_FELADAT'])
                  && (
                    <TabPane tabId="1">
                      <FeladatlistaContent
                        globals={this.props.globals}
                        ref={(instance) => { this.child1 = instance; }}
                        active={this.state.activeTab === '1'}
                      />
                    </TabPane>
                  )
                  }
                  {this.props.globals.hasRole(['FELADATLISTA_FELADATTIPUS'])
                  && (
                    <TabPane tabId="2">
                      <AllapotContent
                        globals={this.props.globals}
                        ref={(instance) => { this.child1 = instance; }}
                        active={this.state.activeTab === '2'}
                      />
                    </TabPane>
                  )
                  }
                  {this.props.globals.hasRole(['FELADATLISTA_FELADATTIPUS'])
                  && (
                    <TabPane tabId="3">
                      <FeladatTipusContent
                        globals={this.props.globals}
                        ref={(instance) => { this.child4 = instance; }}
                        active={this.state.activeTab === '3'}
                      />
                    </TabPane>
                  )
                }
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FeladatListaMenuBase.propTypes = {
  globals: PropTypes.object
};

export default FeladatListaMenuBase;
